import type { PaidBreakExceptionReason } from '#/shared/types/PaidBreakRequest';

import { PaidBreakExceptionCollapsible } from './PaidBreakExceptionCollapsible';
import { PaidBreakExceptionDetails } from './PaidBreakExceptionDetails';

type PaidBreakExceptionAcceptedContentProps = {
  hours: string;
  reason?: PaidBreakExceptionReason;
  notes?: string;
  statusMessage?: string | null;
  defaultExpanded?: boolean;
};

export function PaidBreakExceptionAcceptedContent({
  hours,
  reason,
  notes,
  statusMessage,
  defaultExpanded = false,
}: Readonly<PaidBreakExceptionAcceptedContentProps>) {
  const defaultStatusMessage = statusMessage
    ? statusMessage
    : `The timesheet has been adjusted to add ${hours} ordinary hours.`;

  return (
    <PaidBreakExceptionCollapsible defaultExpanded={defaultExpanded} title={defaultStatusMessage}>
      <PaidBreakExceptionDetails reason={reason} notes={notes} />
    </PaidBreakExceptionCollapsible>
  );
}
